import { atom } from 'jotai'

/**
 * 車両マスタのインポートModalの表示状態
 */
export const isOpenTruckImportModalAtom = atom<boolean>(false)

isOpenTruckImportModalAtom.debugLabel = 'isOpenTruckImportModalAtom'
